import { createAsyncThunk } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import axios from '../utils/axiosInstance';
import { API, getAuthHeaders } from '../config/api';

export const EngagementEventTypes = {
  PROFILE_VIEWED: 'supplier.profile.viewed',
  SEARCH_PERFORMED: 'supplier.search.performed',
  SEARCH_CLICKTHROUGH: 'supplier.search.clickthrough',
  AI_MATCH_GENERATED: 'ai.match.generated',
  SUPPLIER_SAVED: 'supplier.saved',
  QUOTE_REQUEST_SENT: 'quote.request.sent',
  RFP_INVITE_SENT: 'rfp.invite.sent',
};

const ingestUrl = () => `${API.engagement}/api/v1/events/ingest`;
const aggregateUrl = () => `${API.engagement}/api/v1/events/aggregate`;

export const trackEngagementEvent = createAsyncThunk(
  'engagementEvents/track',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const tenantId = state.auth?.tenantId;
      const token = state.auth?.token;
      let actorId = state.auth?.id;

      if (token) {
        try {
          actorId = jwtDecode(token).sub ?? actorId;
        } catch {
          // keep fallback actorId
        }
      }

      if (!tenantId || !actorId) {
        return rejectWithValue('Missing tenant or user for engagement tracking');
      }

      const body = {
        eventType: payload.eventType,
        tenantId,
        actorId: String(actorId),
        supplierId: payload.supplierId,
        departmentId: payload.departmentId ?? 'other',
        sessionId: payload.sessionId,
        metadata: payload.metadata ?? {},
        timestamp: new Date().toISOString(),
      };

      const headers = getAuthHeaders(getState);

      await axios.post(ingestUrl(), body, { headers });

      await axios
        .post(aggregateUrl(), {}, { headers })
        .catch(() => undefined);

      return body;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ?? error.message ?? 'Failed to track event',
      );
    }
  },
);
